import { z } from 'zod/v4';

export const TASK_ACTION_TYPES = [
  'skip',
  'complete',
  'postpone',
  'assign',
  'revert',
  'delete',
] as const;

export type TaskActionType = (typeof TASK_ACTION_TYPES)[number];

export const TaskActionTypeSchema = z.enum([...TASK_ACTION_TYPES]);
